export default __webpack_public_path__ + "static/media/glimmerjs.65c93b13.svg";